module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_fooldal3.a9548ff3.jpg";